<script>
import ImageUplord from "@/components/ImageUplord";
import APIStudent from "@/mixins/APIStudent";
export default {
  extends: ImageUplord,
  mixins: [APIStudent],
  data() {
    return {
      fileUploadFormData: new FormData(),
      image: null,
      userId: "",

      isLoading: false,
      fullPage: false
    };
  },
  computed: {
    contactImage: function() {
      if (this.image) {
        return this.image;
      } else {
        return "/static/user@2x.png";
      }
    },
    queriedUrlCId() {
      let url = window.location.href.split("create/");
      let url2 = url[1].split("/");
      return url2[0];
    },
    queriedUrlSid() {
      let url = window.location.href.split("create/");
      let url1 = url[1].split("/");
      return url1[1];
    },
    studentId: {
      get() {
        return this.$store.state.student.studentId.payload._id;
      }
    }
  },
  created() {
    this.restoreFrom();
    this.formData();
  },
  methods: {
    formData: function() {
      if (this.queriedUrlSid !== "0") {
        this.userId = this.queriedUrlSid;
      } else {
        this.userId = this.studentId;
      }
    },
    restoreFrom: async function() {
      if (this.$route.params.object !== undefined) {
        this.image = this.$route.params.object.image;
      } else if (
        this.$route.params.object === undefined &&
        this.queriedUrlSid !== "0"
      ) {
        try {
          let responce = await this.geStudentById(this.queriedUrlSid);
          this.image = responce.image;
        } catch (error) {
          this.$toast.error("Cannot get details!", "Error", {
            position: "topCenter"
          });
        }
      }
    },
    getFile: async function(eventf) {
      var tgt = eventf.target || window.event.srcElement;
      let files = tgt.files;

      let self = this;
      if (FileReader && files && files.length) {
        var fr = new FileReader();
        fr.onload = function() {
          self.image = fr.result;
        };
        fr.readAsDataURL(files[0]);
      }
      await this.fileUploadFormData.append("image", tgt.files[0]);
      await this.fileUploadFormData.set("_id", this.userId);
      await this.fileUploadFormData.set("path", "student");

      let formData = await this.fileUploadFormData;
      try {
        await this.postStudentImage(formData);
        this.$toast.success("Success", "submitted", {
          position: "topCenter"
        });
        if (this.queriedUrlSid === "0") {
          this.$router.push({
            name: "Students",
            params: { id: this.queriedUrlCId }
          });
        }
      } catch (error) {
        this.$toast.error("Failed to submit details", "Error", {
          position: "topCenter"
        });
      }
    }
  }
};
</script>
